<template lang='pug'>
.custom-map-content
  .floating-panel
    //- el-button(size='small' @click='handleOverlay()') {{ mapVisible ? '隱藏' : '顯示' }}校園區域
    el-button(size='small' @click='getGPS()') 定位
    el-button(size='small' @click='dropMarkers()') 顯示編號
    el-button(size='small' @click='dropAED()') AED 設施
    el-button(size='small' @click='dropAC()') 無障礙坡道
    el-button(size='small' @click='resetView()') 回到中原
    //- <input type="button" value="隱藏校園區域" @click="removeOverlay();">
    //- <input type="button" value="顯示校園區域" @click="addOverlay();">
    //- <input type="button" value="顯示所有地點" @click="dropMarkers();">
  #custom-map
  .floating-panel-rwd
    //- el-button(size='small' @click='handleOverlay()') {{ mapVisible ? '隱藏' : '顯示' }}校園區域
    el-button(size='small' @click='getGPS()') 定位
    el-button(v-if='showNumber' size='small' @click='dropMarkers()') 顯示編號
    el-button(v-if='showAED' size='small' @click='dropAED()') AED 設施
    el-button(v-if='showAC' size='small' @click='dropAC()') 無障礙坡道
    el-button(size='small' @click='resetView()') 回到中原
</template>

<script>
import google from 'google';
import cycuBuildsData from '@/data/cycuBuilds';
import cycuPlaceData from '@/data/cycuPlace';
import cycuAedData from '@/data/aed';
import cycuAcDate from '@/data/accessibleChannel';

export default {
  name: 'CustomMap',
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    currentArea: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      map: null,
      overlay: null,
      historicalOverlay: null,
      // GpsInfoWindow: null,
      currentMarker: '',
      infoWindow: '',
      infoWindowAll: [],
      cycuBuilds: cycuBuildsData,
      cycuPlace: cycuPlaceData,
      cycuAED: cycuAedData,
      cycuAC: cycuAcDate,
      markers: [],
      AEDMarkers: [],
      ACMarkers: [],
      mapVisible: true,
      customStyle: [
        {
          featureType: 'all',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'all',
          elementType: 'labels.text.fill',
          stylers: [
            {
              saturation: 36,
            },
            {
              color: '#000000',
            },
            {
              lightness: 40,
            },
          ],
        },
        {
          featureType: 'all',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              visibility: 'on',
            },
            {
              color: '#000000',
            },
            {
              lightness: 16,
            },
          ],
        },
        {
          featureType: 'all',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#000000',
            },
            {
              lightness: 20,
            },
          ],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#000000',
            },
            {
              lightness: 17,
            },
            {
              weight: 1.2,
            },
          ],
        },
        {
          featureType: 'administrative.country',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#e5c163',
            },
          ],
        },
        {
          featureType: 'administrative.locality',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#c4c4c4',
            },
          ],
        },
        {
          featureType: 'administrative.neighborhood',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#e5c163',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000',
            },
            {
              lightness: 20,
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000',
            },
            {
              lightness: 21,
            },
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'poi.business',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#e5c163',
            },
            {
              lightness: '0',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#e5c163',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000',
            },
            {
              lightness: 18,
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#575757',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#2c2c2c',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000',
            },
            {
              lightness: 16,
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#999999',
            },
          ],
        },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000',
            },
            {
              lightness: 19,
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#000000',
            },
            {
              lightness: 17,
            },
          ],
        },
      ],
      directionsService: null,
      directionsRenderer: null,
      watchOptions: '',
      userLatLng: {
        lat: null,
        lng: null,
      },
      quickMode: false,
      quickId: null,
      aedMode: false,
      acMode: false,
      bNumber: false,
      bAED: false,
      bAC: false,
    };
  },
  computed: {
    showNumber() {
      return this.bNumber;
    },
    showAED() {
      return this.bAED;
    },
    showAC() {
      return this.bAC;
    },
  },
  created() {
  },
  mounted() {
    this.emitMounted();
    // console.log('this.cycuPlace :', this.cycuPlace);
  },

  methods: {
    emitMounted() {
      this.$emit('onMounted', true);
    },
    initMap() {
      // check for Geolocation support
      if (navigator.geolocation) {
        console.log('Geolocation is supported!');
      } else {
        console.log('Geolocation is not supported for this Browser/OS version yet.');
      }
      this.currentMarker = new google.maps.Marker({
        // icon: image,
        map: this.map,
        // position: ,
        title: 'Current Position',
      });

      this.watchOptions = { enableHighAccuracy: true, timeout: 5000, maximumAge: 5 * 60 * 1000 };
      // navigator.geolocation.getCurrentPosition(this.updateGeoPosition, this.onGeoError, this.watchOptions);
      // 取得及時位置
      navigator.geolocation.watchPosition(this.updateGeoPosition, this.onGeoError, this.watchOptions);

      this.directionsService = new google.maps.DirectionsService();
      this.directionsRenderer = new google.maps.DirectionsRenderer({
        polylineOptions: {
          strokeColor: 'red',
          strokeWeight: '5',
        },
      });

      this.map = new google.maps.Map(document.getElementById('custom-map'), {
        zoom: 16.5, // this.isMobile ? 16 : 17,
        center: { lat: 24.9579551, lng: 121.2434948 },
        streetViewControl: false,
        // disableDefaultUI: true,
        // mapTypeControlOptions: false,
        zoomControl: true,
        // ZoomControlOptions: {
        //   position: google.maps.ControlPosition.C,
        // },
        mapTypeControl: false,
        mapTypeId: 'terrain',
        styles: [],
      });

      this.directionsRenderer.setMap(this.map);

      var imageBounds = {
        north: 24.962785, // 右上
        east: 121.247370, // 右上
        south: 24.954961, // 左下
        west: 121.239791, // 左下
      };

      this.map.setOptions({
        styles: this.customStyle,
      });

      this.historicalOverlay = new google.maps.GroundOverlay(
        './cycu-map-01_2026.svg',
        imageBounds,
      );

      this.addOverlay();
      if (this.aedMode === false && this.acMode === false) {
        this.dropMarkers();
      }

      if (this.quickMode) {
        // console.log('this.cycuBuilds[this.quickId] :', this.quickId);
        window.setTimeout(() => {
          this.map.setOptions({
            zoom: 18,
            // center: this.cycuBuilds[this.quickId].position,
          });
          this.openInfoWindows(this.quickId);
        }, 1000);
        this.quickMode = false;
      }

      if (this.aedMode) {
        console.log('aed drop');
        window.setTimeout(() => {
          this.dropAED();
        }, 1000);
        this.aedMode = false;
      }

      if (this.acMode) {
        window.setTimeout(() => {
          this.dropAC();
        }, 1000);
        this.acMode = false;
      }
    },
    // overlay functions
    addOverlay() {
      this.historicalOverlay.setMap(this.map);
      this.mapVisible = true;
    },
    handleOverlay() {
      this.mapVisible = !this.mapVisible;
      if (this.mapVisible){
        this.historicalOverlay.setMap(this.map);
      } else {
        this.historicalOverlay.setMap(null);
      }
    },
    resetView() {
      this.initMap();
    },
    setNumberView() {
      this.bNumber = false;
      this.bAED = true;
      this.bAC = true;
      this.quickMode = false;
      this.aedMode = false;
      this.acMode = false;
      this.initMap();
    },

    setCenter(id) { // 自訂位置
      this.bNumber = false;
      this.bAED = true;
      this.bAC = true;
      this.aedMode = false;
      this.acMode = false;
      this.quickMode = true;
      this.quickId = id;
      this.initMap();
    },
    setAedView() {
      this.bNumber = true;
      this.bAED = false;
      this.bAC = true;
      this.quickMode = false;
      this.acMode = false;
      this.aedMode = true;
      this.initMap();
    },
    setAcView() {
      this.bNumber = true;
      this.bAED = true;
      this.bAC = false;
      this.quickMode = false;
      this.aedMode = false;
      this.acMode = true;
      this.initMap();
    },

    // handle GPS
    getGPS() {
      const GpsInfoWindow = new google.maps.InfoWindow();

      var pos = {
        lat: this.userLatLng.lat, // position.coords.latitude,
        lng: this.userLatLng.lng, // position.coords.longitude,
      };
      GpsInfoWindow.setPosition(pos);
      GpsInfoWindow.setContent('您的位置！');
      GpsInfoWindow.open(this.map);
      this.map.setCenter(pos);
      // Try HTML5 geolocation.
      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition((position) => {
      //     var pos = {
      //       lat: this.userLatLng.lat, // position.coords.latitude,
      //       lng: this.userLatLng.lng, // position.coords.longitude,
      //     };
      //     GpsInfoWindow.setPosition(pos);
      //     GpsInfoWindow.setContent('您的位置！');
      //     GpsInfoWindow.open(this.map);
      //     this.map.setCenter(pos);
      //   }, () => {
      //     this.handleLocationError(true, GpsInfoWindow, this.map.getCenter());
      //   });
      // } else {
      //   // Browser doesn't support Geolocation
      //   this.handleLocationError(false, GpsInfoWindow, this.map.getCenter());
      // }
    },
    handleLocationError(browserHasGeolocation, infoWindow, pos) {
      infoWindow.setPosition(pos);
      infoWindow.setContent(
        browserHasGeolocation
          ? 'GPS定位失敗！<br/>請確認您允取定位權限。'
          : '您的瀏覽器不支援GPG定位，<br/>請使用其他瀏覽器。',
      );
      infoWindow.open(this.map);
    },
    // marker drop functions
    dropMarkers() {
      this.clearMarkers(this.markers);
      this.cycuBuilds.forEach((item, index, array) => {
        this.addMarkerWithTimeout(this.markers, item, 50);
      });
    },
    addMarkerWithTimeout(markers, build, timeout) {
      window.setTimeout(() => {
        // console.log('svgPath :', svgPath);
        const targetMarker = new google.maps.Marker({
          icon: {
            url: build.path,
            scaledSize: new google.maps.Size(20, 20),
          },
          optimized: false,
          position: build.position, // 號碼位置
          map: this.map,
          animation: google.maps.Animation.DROP,
        });
        markers.push(targetMarker);

        // console.log('this.cycuPlace :', this.cycuPlace);
        const places = this.cycuPlace.filter((item, index, array) => {
          return item.build === build.label;
        });
        // console.log('places :', places);

        var contentString =
          '<div id="marker-content">' +
          // svg.svg +
          '<image src="' + build.path + '" style="width:30px;height:30px"/>' +
          '<span class="firstHeading">' + build.label + '</span>';

        if (places.length > 0) {
          places.forEach((item, index, array) => {
            contentString += '<div class="label-text">' + item.label + '</div>';
          });
        }

        contentString += '<div id="goBtn" class="a-button">開 始 指 引</div>' +
        '<div class="a-button"><a href="' + build.url + '" target="_blank">以 App 導 航</a></div>' +
        '</div>';

        const _infoWindow = new google.maps.InfoWindow({
          content: contentString,
          // maxWidth: 300,
        });

        targetMarker.addListener('click', e => {
          // 如果目前有開啟中的訊息視窗，先將其關閉
          if (this.infoWindow) {
            this.infoWindow.close();
          }
          // 顯示被點擊地標的訊息視窗
          _infoWindow.open(this.map, targetMarker);

          _infoWindow.addListener('domready', () => {
            var btn = document.getElementById('goBtn');
            btn.addEventListener('click', e => {
              console.log('goBtn :', e);
              this.startDirection(build.entry); // 入口位置
              if (this.infoWindow) {
                this.infoWindow.close();
              }
            });
          });
          // 存入目前開啟的訊息視窗
          this.infoWindow = _infoWindow;
        });

        this.infoWindowAll[build.id] = {
          openWindow: () => {
            if (this.infoWindow) {
              this.infoWindow.close();
            }
            // 顯示被點擊地標的訊息視窗
            _infoWindow.open(this.map, targetMarker);

            _infoWindow.addListener('domready', () => {
              var btn = document.getElementById('goBtn');
              btn.addEventListener('click', e => {
                console.log('goBtn :', e);
                this.startDirection(build.entry); // 入口座標
                if (this.infoWindow) {
                  this.infoWindow.close();
                }
              });
            });
            // 存入目前開啟的訊息視窗
            this.infoWindow = _infoWindow;
          },
        };
      }, timeout);
    },
    openInfoWindows(id) {
      this.infoWindowAll[id].openWindow();
    },

    clearMarkers(markers) {
      for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }
      markers = [];
    },

    // AED
    dropAED() {
      this.clearMarkers(this.AEDMarkers);
      this.cycuAED.forEach((item, index, array) => {
        this.addMarkerWithTimeout(this.AEDMarkers, item, 50);
      });
    },

    // Accessible Channel
    dropAC() {
      this.clearMarkers(this.ACMarkers);
      this.cycuAC.forEach((item, index, array) => {
        this.addMarkerWithTimeout(this.ACMarkers, item, 50);
      });
    },

    // direction
    getRealTimePosition() {
      console.log('this.userLatLng :', this.userLatLng);
      // 放置marker
      // eslint-disable-next-line no-unused-vars
      this.currentMarker = new google.maps.Marker({
        // position: { lat: 24.957138, lng: 121.241688 },
        position: { lat: this.userLatLng.lat, lng: this.userLatLng.lng },
        map: this.map,
      });
    },

    updatePositionTimer() {
      this.time = setInterval(() => {
        this.getRealTimePosition();
      }, 1000);
    },

    updateGeoPosition(position) {
      this.userLatLng.lat = position.coords.latitude;
      this.userLatLng.lng = position.coords.longitude;
      console.log('start watchPosition', this.userLatLng);
      this.setMarkerPosition(position);
    },
    onGeoError(error) {
      console.log('Error occurred. Error code: ' + error.code);
    },
    setMarkerPosition(position) {
      this.currentMarker.setPosition(new google.maps.LatLng(position.coords.latitude, position.coords.longitude));
    },

    startDirection(targetPosition) {
      // map.panTo(new google.maps.LatLng( //移動marker icon至 移動中的座標
      //   pos.coords.latitude,
      //   pos.coords.longitude,
      // ));
      // this.currentMarker = new google.maps.Marker({
      //   // icon: image,
      //   map: this.map,
      //   position: targetPosition,
      //   title: 'Current Position',
      // });

      // // 取得及時位置
      // navigator.geolocation.watchPosition(this.updateGeoPosition, this.onGeoError, this.watchOptions);

      this.calculateAndDisplayRoute(this.directionsService, this.directionsRenderer, targetPosition);
    },

    calculateAndDisplayRoute(directionsService, directionsRenderer, targetPosition) {
      console.log('targetPosition :', targetPosition.lat, targetPosition.lng);
      var pos1 = new google.maps.LatLng(this.userLatLng.lat, this.userLatLng.lng);
      // var pos2 = new google.maps.LatLng(24.957138, 121.241688);
      var pos2 = new google.maps.LatLng(targetPosition.lat, targetPosition.lng);
      directionsService.route(
        {
          origin: pos1,
          destination: pos2,
          travelMode: 'DRIVING',
        },
        (response, status) => {
          if (status === 'OK') {
            directionsRenderer.setDirections(response);
          } else {
            console.log('userLatLng :', this.userLatLng);
            window.alert('請重新整理頁面，並確認是以允許定位服務。');
            // window.alert('請重新整理頁面：Directions request failed due to ' + status);
          }
        });
    },
  },
};
</script>

<style lang='scss' scoped>
/* Always set the map height explicitly to define the size of the div
       * element that contains the map. */
#custom-map {
  height: 70vh;
}

.floating-panel {
  position: absolute;
  top: 10px;
  left: 25%;
  z-index: 5;
  background-color: #333;
  padding: 5px;
  border: none;
  text-align: center;
  // font-family: 'Roboto', 'sans-serif';
  line-height: 30px;
  padding-left: 10px;
}

.floating-panel-rwd {
  display: none;
}

/deep/ #marker-content{
  height: auto;
  max-height: 800px;
  text-align: center;
  font-size: 18px;
  span {
    padding: 1px;
    display: inline-block;
  }
  .label-text {
    margin-top: 8px;
    font-size: 13px;
  }
  a {
    color: #fff;
    background-color: #333;
    padding: 7px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 3px;
    text-decoration: none;
    font-weight: 400;
  }
  .a-button {
    margin-top: 20px;
    color: #fff;
    background-color: #333;
    padding: 7px;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 3px;
    text-decoration: none;
    font-weight: 400;
    font-size: 13px;
    z-index: 999;
    cursor: pointer;
  }
  .black-number {
    width: 25px;
    margin-top: 5px;
    margin-right: 10px;
  }
}

/deep/ .gm-style-iw {
  color: #333;
  max-height: 650px !important;
}

@media (max-width: 767.98px) {
  .floating-panel {
    display: none;
  }
  .floating-panel-rwd {
    display: block;
    padding-top: 20px;
  }
}
</style>
